$(document).ready(function() {
  $(document).ajaxComplete(function(event, xhr, settings) {
    if (settings.url === '/cart/change.js' || settings.url.indexOf('/cart/change.js') !== -1) {
      setTimeout(function() {
        try {
          var cart = JSON.parse(xhr.responseText);
          $.each(cart.items, function(index, item) {
            var key = item.key;
            // Use attribute selector to avoid jQuery syntax errors with colons in the key
            var row = $('[id="updates_' + key + '"]').closest('.cart_item');
            if (row.length) {
              row.find('.product-subtotal').html(Shopify.formatMoney(item.final_line_price || item.line_price, theme.moneyFormat));
              row.find('.cart__price-wrapper div:not(.hidden):not(.cart-item__discount)').html(Shopify.formatMoney(item.price, theme.moneyFormat));
            }
          });
          $('.cart__subtotal').html(Shopify.formatMoney(cart.total_price, theme.moneyFormat));
        } catch(e) {
          console.error("Custom JS B2B cart price update failed:", e);
        }
      }, 300); // 300ms delay to ensure it overwrites theme JS
    }
  });
});
